import React from 'react'
import { useTranslation } from "next-i18next";
import Head from 'next/head';
import Layout from '@/components/shared/Layout'
import PeerstackImage from '../../public/images/Peerstack 1200x630.jpeg';
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import ScrollToTopButton from '@/components/shared/ScrollToTopButton'
import WhatsappButton from '@/components/shared/WhatsappButton'

const SECTIONS = [
    { id: 1, clauses: ['1-1', '1-2', '1-3'] },
    { id: 2, clauses: ['2-1', '2-2', '2-3', '2-4'] },
    {
        id: 3,
        clauses: [
            '3-1', '3-1-1', '3-2', '3-2-1', '3-2-2', '3-2-3', '3-2-4',
            '3-3', '3-4', '3-5', '3-6',
        ],
    },
    { id: 4, subtitle: true, clauses: ['4-1', '4-2'] },
    {
        id: 5,
        clauses: [
            '5-1', '5-2', '5-3', '5-4', '5-5', '5-6', '5-7', '5-8', '5-9',
            '5-10', '5-10-1', '5-10-2', '5-10-3', '5-10-4', '5-10-5',
            '5-10-6', '5-10-7', '5-10-8', '5-10-9', '5-10-10',
            '5-11', '5-12',
        ],
    },
    { id: 6, clauses: ['6-1', '6-2', '6-3'] },
    { id: 7, clauses: ['7-1', '7-1-1', '7-2'] },
    { id: 8, clauses: ['8-1', '8-2'] },
    { id: 9, clauses: ['9-1'], email: true },
]

const PARAGRAPH = 'text-[15px] md:text-[16px] text-[#4b5563] leading-[1.85]'

export async function getServerSideProps({ locale }) {
    return {
        props: {
            ...(await serverSideTranslations(locale || "az")),
        },
    };
}

const PrivacyPolicyPage = () => {
    const { t } = useTranslation();
    return (
        <>
            <Head>
                <meta charSet="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <title>{t("privacy-page.meta-title")}</title>
                <meta name="keywords" content="peerstack tech privacy policy" />
                <meta name="description" content={t("privacy-page.meta-description")} />
                <meta name="image" content={PeerstackImage.src} />
                <link rel="canonical" href="https://peerstack.tech/privacy-policy" />
                <meta property="og:site_name" content="peerstack.tech" />
                <meta property="og:title" content={t("privacy-page.meta-title")} />
                <meta property="og:url" content="https://peerstack.tech/privacy-policy" />
                <meta property="og:description" content={t("privacy-page.meta-description")} />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={PeerstackImage.src} />
            </Head>
            <Layout>
                <div className="pt-[40px] pb-[70px] md:pt-[56px] md:pb-[96px]">
                    <div className="w-[90%] mx-auto">
                        <h1 className="text-[30px] md:text-[38px] font-semibold text-center text-main mb-[28px] md:mb-[36px]">
                            {t("privacy-page.page-title")}
                        </h1>

                        <ol className="flex flex-col gap-[24px]">
                            {SECTIONS.map(({ id, clauses, subtitle, email }) => (
                                <li key={id}>
                                    <h2 className="text-[19px] md:text-[22px] font-semibold text-main mb-[8px]">
                                        {id}. {t(`privacy-page.section-${id}-title`)}
                                    </h2>
                                    <div className="pl-[8px] flex flex-col gap-[8px]">
                                        {subtitle && (
                                            <p className={`${PARAGRAPH} font-semibold text-[#374151]`}>
                                                {t(`privacy-page.section-${id}-subtitle`)}
                                            </p>
                                        )}
                                        {clauses.map(clause => (
                                            <div
                                                key={clause}
                                                className={PARAGRAPH}
                                                style={{ paddingLeft: (clause.split('-').length - 2) * 16 }}
                                                dangerouslySetInnerHTML={{
                                                    __html: `${clause.split('-').join('.')}. ${t(`privacy-page.section-${clause}`)}`,
                                                }}
                                            />
                                        ))}
                                        {email && (
                                            <div
                                                className={PARAGRAPH}
                                                dangerouslySetInnerHTML={{ __html: t("privacy-page.section-9-email") }}
                                            />
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ol>

                        <p className="text-[14px] md:text-[15px] text-[#6b7280] italic mt-[28px]">
                            {t("privacy-page.last-updated")}
                        </p>
                    </div>
                </div>

                <ScrollToTopButton />
                <WhatsappButton />
            </Layout>
        </>
    )
}

export default PrivacyPolicyPage
